<div class="wg-wrapper">
  <div class="wg-toolbar">
    @if (editable()) {
      <span class="wg-hint">
        <i class="fa-solid fa-circle-info"></i>
        Clicca un’azione dal catalogo · trascina un’uscita su un nodo per collegarla
      </span>
      <span class="wg-zoom-controls">
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Zoom out" (click)="zoomOut()">−</button>
        <span class="wg-zoom-value">{{ (zoom() * 100).toFixed(0) }}%</span>
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Zoom in" (click)="zoomIn()">+</button>
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Fit" (click)="fitToView()">Fit</button>
      </span>
      <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" (click)="resetLayout()">
        <i class="fa-solid fa-arrows-to-dot"></i> Reset layout
      </button>
    } @else {
      <span class="wg-legend">
        <span class="wg-legend-item"><span class="wg-legend-dot success"></span> Success</span>
        <span class="wg-legend-item"><span class="wg-legend-dot failed"></span> Failed</span>
        <span class="wg-legend-item"><span class="wg-legend-dot running"></span> Running</span>
        <span class="wg-legend-item"><span class="wg-legend-dot queued"></span> Queued</span>
        <span class="wg-legend-item"><span class="wg-legend-dot skipped"></span> Skipped</span>
        <span class="wg-legend-item"><span class="wg-legend-dot"></span> Not executed</span>
      </span>
      <span class="wg-zoom-controls">
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Zoom out" (click)="zoomOut()">−</button>
        <span class="wg-zoom-value">{{ (zoom() * 100).toFixed(0) }}%</span>
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Zoom in" (click)="zoomIn()">+</button>
        <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" title="Fit" (click)="fitToView()">Fit</button>
      </span>
      <button type="button" class="fq-btn fq-btn-sm fq-btn-secondary" (click)="resetLayout()">
        <i class="fa-solid fa-arrows-to-dot"></i> Reset layout
      </button>
    }
  </div>

  <div class="wg-canvas" (click)="onCanvasClick()" (keydown.enter)="onCanvasClick()" (dragover)="allowDrop($event)" (drop)="onCanvasDrop($event)" (wheel)="onCanvasWheel($event)" tabindex="0" role="button" aria-label="Workflow graph canvas" #canvas>
    <div class="wg-viewport" [style.width.px]="canvasSize().width * zoom()" [style.height.px]="canvasSize().height * zoom()">
    <div class="wg-inner" [style.width.px]="canvasSize().width" [style.height.px]="canvasSize().height" [style.transform]="'scale(' + zoom() + ')'">
      <svg class="wg-edges" [attr.width]="canvasSize().width" [attr.height]="canvasSize().height">
        <defs>
          <marker id="wg-arrow-success" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
            <path d="M0,0 L9,3 L0,6 Z" fill="#2b897a"></path>
          </marker>
          <marker id="wg-arrow-failed" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
            <path d="M0,0 L9,3 L0,6 Z" fill="#dc2626"></path>
          </marker>
          <marker id="wg-arrow-warning" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
            <path d="M0,0 L9,3 L0,6 Z" fill="#d97706"></path>
          </marker>
          <marker id="wg-arrow-start" markerWidth="10" markerHeight="10" refX="8" refY="3" orient="auto" markerUnits="strokeWidth">
            <path d="M0,0 L9,3 L0,6 Z" fill="#475569"></path>
          </marker>
        </defs>

        @for (edge of edges(); track edge.id) {
          <path
            [attr.d]="edge.path"
            [ngClass]="['wg-edge', edge.type, edge.kind]"
            [attr.marker-end]="edge.type === 'start' ? 'url(#wg-arrow-start)' : (edge.type === 'success' ? 'url(#wg-arrow-success)' : (edge.type === 'failed' ? 'url(#wg-arrow-failed)' : 'url(#wg-arrow-warning)'))">
          </path>
          @if (edge.labelVisible) {
            <text
              [attr.x]="edge.labelX"
              [attr.y]="edge.labelY"
              [ngClass]="['wg-edge-label', edge.type, edge.kind]">
              {{ edge.label }}
            </text>
          }
        }
      </svg>

      @if (startPill(); as start) {
        <div class="wg-pseudo start" [style.left.px]="start.x" [style.top.px]="start.y">
          <i class="fa-solid fa-flag"></i> Inizio
        </div>
      }
      @if (endPill(); as end) {
        <div
          class="wg-pseudo end"
          [style.left.px]="end.x"
          [style.top.px]="end.y"
          title="Trascina per riposizionare"
          (pointerdown)="onEndPointerDown($event)"
          (click)="$event.stopPropagation()">
          <i class="fa-regular fa-circle"></i> Fine
        </div>
      }

      @for (node of nodes(); track node.id) {
        <div
          class="wg-node"
          [class.selected]="selectedId() === node.id"
          [class.entry]="node.isEntry"
          [class.connecting]="pendingFrom() === node.id"
          [class.readonly]="!editable()"
          [class.current]="!!node.current"
          [class.dimmed]="!!node.dimmed"
          [class.has-error]="!!node.message"
          [class.tech-fortinet]="node.technology === 'fortinet'"
          [class.tech-cisco]="node.technology === 'cisco'"
          [class.tech-nrd]="node.technology === 'nrd'"
          [ngClass]="node.status ? 'status-' + node.status : ''"
          [attr.data-node-id]="node.id"
          [style.left.px]="positionOf(node.id).x"
          [style.top.px]="positionOf(node.id).y"
          [style.width.px]="nodeWidth"
          [style.height.px]="nodeHeightOf(node)"
          [style.padding-bottom.px]="nodePaddingBottom(node)"
          tabindex="0"
          role="button"
          [attr.aria-label]="node.label"
          (click)="onNodeClick($event, node)"
          (keydown.enter)="onNodeClick($event, node)"
          (dragover)="allowDrop($event)"
          (drop)="onNodeDrop($event, node)"
          (pointerdown)="onNodePointerDown($event, node)">
          <div class="wg-node-head">
            <span class="wg-node-order">{{ node.order + 1 }}</span>
            <span class="wg-node-glyph"><i [class]="node.icon" class="wg-node-icon"></i></span>
            <span class="wg-node-copy">
              <span class="wg-node-label" [title]="node.label">{{ node.label }}</span>
              @if (node.subtitle) {
                <span class="wg-node-subtitle">{{ node.subtitle }}</span>
              }
            </span>
            <button type="button" class="wg-node-menu" title="Azioni step" (click)="toggleNodeMenu($event, node)">⋮</button>
          </div>

          @if (openMenuId() === node.id) {
            <div class="wg-node-menu-panel" (click)="$event.stopPropagation()" (pointerdown)="$event.stopPropagation()">
              <button type="button" [disabled]="node.isEntry" (click)="emitNodeAction($event, node, 'entry')">
                <i class="fa-solid fa-flag"></i> Imposta avvio
              </button>
              <button type="button" (click)="emitNodeAction($event, node, 'duplicate')">
                <i class="fa-regular fa-copy"></i> Duplica
              </button>
              <button type="button" class="danger" (click)="emitNodeAction($event, node, 'remove')">
                <i class="fa-solid fa-trash"></i> Rimuovi step
              </button>
            </div>
          }

          @if (node.message) {
            <div class="wg-node-error">{{ node.message }}</div>
          }

          <div class="wg-node-foot">
            @if (node.isEntry) {
              <span class="wg-entry-badge"><i class="fa-solid fa-flag"></i> Avvio</span>
            }
            @if (!editable() && node.status) {
              <span class="wg-status-badge" [ngClass]="node.status">
                <i [class]="statusIcon(node.status)"></i> {{ statusSummary(node) }}
              </span>
            }
            @if (node.tagsCount) {
              <span class="wg-tag-badge"><i class="fa-solid fa-tags"></i> {{ node.tagsCount }}</span>
            }
          </div>

          <span class="wg-handles" [class.readonly]="!editable()">
            @for (output of outputsFor(node); track output.key) {
              <span
                class="wg-handle-row"
                [class.taken]="node.takenOutcome === output.key"
                [class.muted]="node.dimmed || (!!node.takenOutcome && node.takenOutcome !== output.key)"
                [class.readonly]="!editable()"
                [ngClass]="outputSeverityClass(node, output.key)"
                [style.top.px]="handleTop(node, output.key)"
                [draggable]="editable()"
                (dragstart)="onHandleDragStart($event, node, output.key)"
                (dragend)="onHandleDragEnd()"
                (click)="onHandleClick($event, node, output.key)"
                [title]="editable() ? 'Trascina o clicca per collegare l’esito ' + output.label : 'Esito ' + output.label">
                <span class="wg-handle-dot" [ngClass]="outputSeverityClass(node, output.key)"></span>
                <span class="wg-handle-label">{{ outputLabel(node, output.key) }}</span>
              </span>
            }
          </span>
        </div>
      }
    </div>
    </div>
  </div>

  @if (zoom() < 0.8) {
    <div class="wg-minimap" (click)="scrollToMinimap($event)" title="Minimap: clicca per spostarti">
      @for (node of nodes(); track node.id) {
        <span
          class="wg-minimap-node"
          [class.selected]="selectedId() === node.id"
          [style.left.px]="positionOf(node.id).x * minimapScale()"
          [style.top.px]="positionOf(node.id).y * minimapScale()"
          [style.width.px]="nodeWidth * minimapScale()"
          [style.height.px]="nodeHeightOf(node) * minimapScale()">
        </span>
      }
    </div>
  }

  @if (pendingFrom()) {
    <div class="wg-pending-bar">
      <i class="fa-solid fa-link"></i>
      Collegamento <strong>{{ pendingLabel() }}</strong>:
      clicca un nodo di destinazione (o lo sfondo per “Fine”).
      <button type="button" class="fq-btn fq-btn-xs fq-btn-secondary" (click)="cancelPending()">Annulla</button>
    </div>
  }
</div>
